<template>
  <popup
    title="ВЫБЕРИТЕ ПЕРСОНАЖА"

    :value="value"
    :action="false"
    @input="$emit('input', $event)"
  >
    <template v-slot:content>
      <div class="avatars">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide
            v-for="(character, i) in characters"
            :key="i"
          >
            <i
              class="avatar-img"
              :style="{
                'background-image': `url(${character.img_url})`,
              }"
            />
          </swiper-slide>
          <div
            class="swiper-pagination"
            slot="pagination"
          />
        </swiper>
        <div class="swiper-button-prev click-sound"></div>
        <div class="swiper-button-next click-sound"></div>
      </div>
    </template>
    <template v-slot:footer>
      <button
        class="btn click-sound"
        @click="onSelect()"
      >
        Выбрать
      </button>
    </template>
  </popup>
</template>

<script>
  import Popup from '@/components/Popup'

  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'

  export default {
    components: {
      Popup,
      Swiper,
      SwiperSlide
    },
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        swiperOptions: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          mousewheel: false,
          keyboard: false,
          simulateTouch: false,
          effect: 'fade'
        },
        characters: [
          {
            "name": "asian",
            "img_url": "/images/avatars/asian.png"
          },
          {
            "name": "black",
            "img_url": "/images/avatars/black.png"
          },
          {
            "name": "white",
            "img_url": "/images/avatars/white.png"
          },
          {
            "name": "woman",
            "img_url": "/images/avatars/woman.png"
          }
        ]
      }
    },
    methods: {
      onSelect(){
        let selected_character = this.characters[this.$refs.mySwiper.$swiper.activeIndex].name;

        this.$store.commit('setCharacter', selected_character);
        this.$emit('input', false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .avatars {
    position: relative;
    width: 537px;
    margin: auto;
  }
  .avatar-img {
    width: 411px;
    height: 411px;
    margin: auto;
    display: block;
    background: #000716 center bottom no-repeat;
    border-radius: 50%;
  }
  .swiper-button-prev, .swiper-button-next {
    user-select: none;
  }
</style>
